import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {toastr} from "react-redux-toastr";
import { api } from "../../../services/api/api.service";
import { API_DARTS_LISTENERS, API_DARTS_LISTENERS_INIT } from "../../../services/api/api.urls";
import { IdName } from "../../../common/types/IdName";
//import {IGetClientResponse} from "../clients/cmsClientsSlice";
//import { IClient } from "../clients/types";
import { TryCatch } from "../../../services/TryCatch";
import { COMPANY_ABBR } from "../../../common/constants/company";
import { PaginationProps } from "../../../common/types/PaginationProps";
interface IGetListenersResponse {
    pageNum: number,
    pageSize: number,
    totalPages: number
    items: IListener[]
}

export interface IListenersState {
    listeners: IListener[]
    clients: IListenerClient[]
    //allClients: IClient[]
    clientId: any
    pagination: PaginationProps,
    noContent: boolean
    loader: boolean
}

export interface IListener {
    id: number,
    isActive: boolean
    name: string
    email: string
    whiteIPs: string
    socketKey: string
    clientId: number,
    competitionId: number,
}

export interface ICreateListenerPayload {
    clientId: number,
    competitionId: number
    isActive: boolean,
    name: string,
    email: string,
    whiteIPs: string,
    socketKey: string
}

export interface IUpdateListenerPayload extends ICreateListenerPayload {
    id: number
}

export interface IListenerClient {
    id: number,
    name: string,
    items: IdName[]
}

export interface IListenerInitResponse {
    clientsCompetitions: IListenerClient[]
}

const initialState: IListenersState = {
    //allClients: [],
    clientId: null,
    listeners: [],
    clients: [],
    pagination: {
        activePage: 1,
        pageSize: 10,
        totalPages: 1
    },
    noContent: false,
    loader: false
}

export const getListenerInit = createAsyncThunk<IListenerInitResponse, void, { rejectValue: string }>(
    'listeners/init',
    async (query, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_DARTS_LISTENERS_INIT}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, "Failed to init listeners.");
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)
export const getListeners = createAsyncThunk<IGetListenersResponse, string, { rejectValue: string }>(
    'listeners/get',
    async (query, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_DARTS_LISTENERS}?${query}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Failed to fetch listeners.')
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)
//ToDo: ��������� ����� �� �������� ���� �������� � Listeners
//export const getClients = createAsyncThunk<IGetClientResponse, void, { rejectValue: string }>(
//    'listeners/get-all-client',
//    async (query, {rejectWithValue}) => {
//        const result = await TryCatch(
//            () => client.get(`${API_CLIENTS}`).then(res => res.data)
//        );
//        if (!result.success) {
//            toastr.error(COMPANY_ABBR, 'Failed to fetch clients.')
//            return rejectWithValue(result.error);
//        }
//        return result.data;
//    }
//)

export const createListener = createAsyncThunk<IUpdateListenerPayload, ICreateListenerPayload, { rejectValue: string }>(
    'listeners/create',
    async (payload, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.post(`${API_DARTS_LISTENERS}`, payload).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Failed to create listeners.')
            return rejectWithValue(result.error);
        }
        toastr.success(COMPANY_ABBR, "Listener has been created")
        return result.data;
    }
)
export const updateListener = createAsyncThunk<IUpdateListenerPayload, IUpdateListenerPayload, { rejectValue: string }>(
    'listeners/update',
    async (payload, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.put(`${API_DARTS_LISTENERS}`, payload).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Failed to update listeners.')
            return rejectWithValue(result.error);
        }
        toastr.success(COMPANY_ABBR, 'Listener has been updated.')
        return result.data;
    }
)
export const deleteListener = createAsyncThunk<null, number>(
    'listeners/delete',
    async (id, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.delete(`${API_DARTS_LISTENERS}/${id}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Failed to update listeners.')
            return rejectWithValue(result.error);
        }
        toastr.success(COMPANY_ABBR, "Listener has been deleted")
        return result.data;
    }
)

export const ListenersCRUD = createSlice({name: 'ListenersCRUD',
    reducers: {
        setPageNumber: (state, action) => {
            state.pagination.activePage = action.payload
        },
        setListenerClientId: (state, action) => {
            state.clientId = action.payload
        },
        onChangePageSize: (state, action) => {
            state.pagination.pageSize = action.payload
        },
    },

    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getListenerInit.fulfilled, (state, action) => {
                state.clients = action.payload.clientsCompetitions
            })
            //.addCase(getClients.fulfilled, (state, action) => {
            //    state.allClients = action.payload.items
            //})
            .addCase(getListeners.fulfilled, (state, action) => {
                state.listeners = action.payload.items
                state.pagination.totalPages = action.payload.totalPages
                state.noContent = action.payload.items.length === 0;
            })
            .addCase(createListener.fulfilled, (state, action) => {
                state.listeners.push(action.payload)
            })
            .addCase(updateListener.fulfilled, (state, action) => {
                state.listeners.map(listener => {
                    if (listener.id === action.payload.id) {
                        return action.payload
                    } else {
                        return listener
                    }
                })
            })
            .addCase(deleteListener.fulfilled, (state, action) => {
                state.listeners = state.listeners.filter(listener => listener.id !== action.meta.arg)
            })
    },
});

export const {setPageNumber, setListenerClientId, onChangePageSize} = ListenersCRUD.actions

export default ListenersCRUD.reducer;
